import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_EVALUATIONCRITERIA } from "../../../../utils/constants";
import { VendorInterface } from "../../../../models/ProcurementModule/Vendor";
import EvaluationCriteriaService from "../../../../services/procurementService/EvaluationCriteriaService";

interface DeleteEvaluationCriteriaContext {
  previousEvaluationCriterias: VendorInterface[];
  deletedEvaluationCriteria: VendorInterface | undefined;
}

const useDeleteEvaluationCriteria = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, string, DeleteEvaluationCriteriaContext>({
    mutationFn: EvaluationCriteriaService.Remove,

    onMutate: (dataId: string) => {
      const previousEvaluationCriterias =
        queryClient.getQueryData<VendorInterface[]>([
          CACHE_KEY_EVALUATIONCRITERIA,
          page,
          pageSize,
        ]) || [];

      queryClient.setQueryData<VendorInterface[]>(
        [CACHE_KEY_EVALUATIONCRITERIA, page, pageSize],
        previousEvaluationCriterias.filter((data) => data.id !== dataId)
      );

      return {
        previousEvaluationCriterias,
        deletedEvaluationCriteria: previousEvaluationCriterias.find(
          (data) => data.id === dataId
        ),
      };
    },

    onError: (error, dataId, context) => {
      if (!context) return;

      queryClient.setQueryData<VendorInterface[]>(
        [CACHE_KEY_EVALUATIONCRITERIA, page, pageSize],
        context.previousEvaluationCriterias
      );
    },

    onSuccess: () => {
      // Optionally, you could perform additional actions on success
      // For example, invalidating queries or updating other parts of the state
    },
  });
};

export default useDeleteEvaluationCriteria;
